import config from '../config/config';
import api from '../config/apiConfig';
import util from './util';
import httpUtil from './httpUtil';
import job from "./job";
//aps
let sdnJob = {};

//泛用：根据Type获取代码和名称
sdnJob.getCodeByType = function (vm,para) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.codeByType, para, function (response) {
		response.data.data.forEach(item => {
			res.push({
				code: item.code,
				codeNm: item.codeNm,
			});
		});
	});
	return res;
};

// 代码类型（描述）
sdnJob.getCodeTypeList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.codeTypeList, job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				codeType: item.codeType,
				comment: item.comment,
			});
		});
	});
	return res;
};
// 产线
sdnJob.getLineTypeList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.lineTypeList, job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				lineId: item.id,
				line: item.code,
				lineNm: item.codeNm,
			});
		});
	});
	return res;
};

// 日程安排
sdnJob.getScheduleTypeList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.scheduleTypeList, job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				scheduleId: item.id,
				schedule: item.code,
				scheduleNm: item.codeNm,
			});
		});
	});
	return res;
};
// 暂停原因
sdnJob.getPauseReasonList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.pauseReasonList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				pauseReasonId: item.id,
				pauseReason: item.code,
				pauseReasonNm: item.codeNm,
			});
		});
	});
	return res;
};

// aps销售订单状态
sdnJob.getOrderStatusList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.orderStatusList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				orderStatusId: item.id,
				orderStatus: item.code,
				orderStatusNm: item.codeNm,
			});
		});
	});
	return res;
};

// wms销售订单状态
sdnJob.getWmsOrderStatusList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.wmsOrderStatusList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				wmsOrderStatusId: item.id,
				wmsOrderStatus: item.code,
				wmsOrderStatusNm: item.codeNm,
			});
		});
	});
	return res;
};

// 生产计划状态
sdnJob.getPlanStatusList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.planStatusList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				planStatusId: item.id,
				planStatus: item.code,
				planStatusNm: item.codeNm,
			});
		});
	});
	return res;
};

// 码头
sdnJob.getYardCodeList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.yardCodeList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				yardId: item.id,
				yard: item.code,
				yardNm: item.codeNm,
			});
		});
	});
	return res;
};

// 订单类型
sdnJob.getOrderTypeList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.orderTypeList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				orderTypeId: item.id,
				orderType: item.code,
				orderTypeNm: item.codeNm,
			});
		});
	});
	return res;
};

// 品质
sdnJob.getQcTypeList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.qcTypeList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				qcTypeId: item.id,
				qcType: item.code,
				qcTypeNm: item.codeNm,
			});
		});
	});
	return res;
};

// 需求类型
sdnJob.getOrderKindList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.orderKindList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				orderKindId: item.id,
				orderKind: item.code,
				orderKindNm: item.codeNm,
			});
		});
	});
	return res;
};

// 计划类型
sdnJob.getPlanTypeList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.planTypeList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				planTypeId: item.id,
				planType: item.code,
				planTypeNm: item.codeNm,
			});
		});
	});
	return res;
};

// 省份
sdnJob.getProvinceTypeList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.provinceTypeList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				provinceId: item.id,
				province: item.code,
				provinceNm: item.codeNm,
			});
		});
	});
	return res;
};

// 库存类型
sdnJob.getStockTypeList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.stockTypeList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				stockTypeId: item.id,
				stockType: item.code,
				stockTypeNm: item.codeNm,
			});
		});
	});
	return res;
};

// 警告类型
sdnJob.getWarningTypeList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.getListWarningType,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				warningTypeId: item.id,
				warningType: item.code,
				warningTypeNm: item.codeNm,
			});
		});
	});
	return res;
};

// 仓库名称
sdnJob.getWarehouseTypeList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.warehouseTypeList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				warehouseTypeId: item.id,
				warehouseType: item.code,
				warehouseTypeNm: item.codeNm,
			});
		});
	});
	return res;
};

/*// 分销渠道
sdnJob.getSalesChannelList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.salesChannelList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				salesChannel: item.code,
				salesChannelNm: item.codeNm,
			});
		});
	});
	return res;
};*/

// 排程规则
sdnJob.getProcessRulesList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.processRulesList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				processRulesId: item.id,
				processRules: item.code,
				processRulesNm: item.codeNm,
			});
		});
	});
	return res;
};

// 成交方式
sdnJob.getDeliveryTermsList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.deliveryTermsList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				deliveryTermsId: item.id,
				deliveryTerms: item.code,
				deliveryTermsNm: item.codeNm,
			});
		});
	});
	return res;
};

// KC导入对象
sdnJob.getKcImportCustomerList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.kcImportCustomerList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				kcImportCustomerId: item.id,
				kcImportCustomer: item.code,
				kcImportCustomerNm: item.codeNm,
			});
		});
	});
	return res;
};

// 密码维护系数
sdnJob.getPwdConfigList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.pwdConfigList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				pwdConfigId: item.id,
				pwdConfig: item.code,
				pwdConfigNm: item.codeNm,
			});
		});
	});
	return res;
};

// 客户类型
sdnJob.getCustomerTypeList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.customerTypeList,job.listAllParams, function (response) {
		response.data.data.forEach(item => {
			res.push({
				customerTypeId: item.id,
				customerType: item.code,
				customerTypeNm: item.codeNm,
			});
		});
	});
	return res;
};

//采番位数
sdnJob.getSaibanDigitList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.getSaibanDigitList, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				saibanDigitId: item.id,
				saibanDigit: item.code,
				saibanDigitNm: item.codeNm,
			});
		});
	});
	return res;
}
// 车间列表
sdnJob.listPlant = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.getPlantList, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				plantId: item.id,
				plant: item.code,
				plantNm: item.codeNm,
			});
		});
	});
	return res;
}
// 规格列表
sdnJob.listPacking = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.getPackingList, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				packingId: item.id,
				packing: item.code,
				packingNm: item.codeNm,
			});
		});
	});
	return res;
}
// 税别列表
sdnJob.listTax = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.getTaxList, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				taxId: item.id,
				tax: item.code,
				taxNm: item.codeNm,
			});
		});
	});
	return res;
}
// 包装袋列表
sdnJob.listPackingBag = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.getPackingBagList, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				packingBagId: item.id,
				packingBag: item.code,
				packingBagNm: item.codeNm,
			});
		});
	});
	return res;
}
// 托盘列表
sdnJob.listPallet = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.getPalletList, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				palletId: item.id,
				pallet: item.code,
				palletNm: item.codeNm,
			});
		});
	});
	return res;
}
// 订单类型列表
sdnJob.listSalesStatus = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.getlistSalesStatus, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				SalesStatusId: item.id,
				salesStatus: item.code,
				salesStatusNm: item.codeNm,
			});
		});
	});
	return res;
}

// 税别列表
sdnJob.invTypList = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mCode.getInvTypList, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				typId: item.id,
				invTyp: item.code,
				invTypNm: item.codeNm,
			});
		});
	});
	return res;
}

//品名信息列表
sdnJob.listGrade = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.mGrade.getAllGrade, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				grade: item.grade,
			});
		});
	});
	return res;
}
//客户信息列表
sdnJob.listCustomer = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.VCustomer.getAll, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				customerId: item.customerId,
				customerName: item.customerName,
			});
		});
	});
	return res;
}
//根据车间获取所有的grade
sdnJob.getGradeByPlant = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.tStockStatistics.getGradeByPlant, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				grade: item.grade,
			});
		});
	});
	return res;
}
//根据车间品名获取所有的：规格/税别/包装袋/托盘
sdnJob.getOtherFour = function (vm) {
	let res = [];
	httpUtil.ajaxGet(vm, api.tStockStatistics.getOtherFour, {}, function (response) {
		response.data.data.forEach(item => {
			res.push({
				otherFour: item.otherFour,
			});
		});
	});
	return res;
}
export default sdnJob;




// WEBPACK FOOTER //
// ./src/utils/sdnJob.js